// Transportation Method/Type Code (DE 91) — says how a shipment moves.
// Shared by the 810's CAD01, the 856's TD504 and the 210's B306 positions,
// each on its own transaction set's CAD, TD5 or B3 segment.

import type {CodeListEntry} from './types';

export const TRANSPORTATION_METHOD_CODES: CodeListEntry[] = [
  {code: 'M', label: 'Motor (Common Carrier)'},
  {code: 'LT', label: 'Less Than Trailer Load (LTL)'},
  {code: 'U', label: 'Private Parcel Service'},
  {code: 'A', label: 'Air'},
  {code: 'AE', label: 'Air Express'},
  {code: 'E', label: 'Expedited Truck'},
  {code: 'L', label: 'Contract Carrier'},
  {code: 'H', label: 'Customer Pickup'},
  {code: 'P', label: 'Private Carrier'},
  {code: 'R', label: 'Rail'},
  {code: 'X', label: 'Intermodal (Piggyback)'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
